import { CcfBox, CcfTextField, CcfTypography } from '@nice-ccf/ui-controls';
import styles from '../simulator-v2-create-new-journey/simulator-v2-customer-details-tab/simulator-v2-customer-details-tab.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  getSelectedContact,
  setSelectedContact,
} from '../+state/simulatorV2.slice';
import { useEffect, useState } from 'react';
import AWS from 'aws-sdk';
import { awsS3Config } from './utils';
import { useAgentName } from './useAgentName';
/* eslint-disable-next-line */
export interface CustomWorkspaceProps {}

/**
 * @example ` <CustomWorkspace />`
 */
export function CustomWorkspace(props: CustomWorkspaceProps) {
  const selectedContact: any = useSelector(getSelectedContact);
  const dispatch = useDispatch();

  type CustomWorkspaceKey =
    | 'customWorkspaceLabel1'
    | 'customWorkspaceUrl1'
    | 'customWorkspaceLabel2'
    | 'customWorkspaceUrl2'
    | 'customWorkspaceLabel3'
    | 'customWorkspaceUrl3';

  const [updatedContact, setUpdatedContact] = useState<
    Record<CustomWorkspaceKey, string>
  >({} as Record<CustomWorkspaceKey, string>);

  const agentName = useAgentName();

  const s3Config = awsS3Config;

  const S3_BUCKET = s3Config.s3Bucket;
  const initialObjectKey = agentName
    ? `simulatorDB/${agentName}/custom-workspace/custom-workspace.json`
    : null;

  AWS.config.update({
    accessKeyId: s3Config.accessKeyId,
    secretAccessKey: s3Config.secretAccessKey,
    region: s3Config.region,
  });

  const s3 = new AWS.S3();

  useEffect(() => {
    if (!initialObjectKey) return;
    const params = { Bucket: S3_BUCKET, Key: initialObjectKey };

    s3.getObject(params).promise()
      .then((objectData) => {
        const objectDataJson = JSON.parse(
          objectData.Body?.toString('utf-8') ?? ''
        );
        setUpdatedContact((prev) => ({
          ...prev,
          customWorkspaceLabel1: objectDataJson.customWorkspaceLabel1 || selectedContact?.customWorkspaceLabel1,
          customWorkspaceLabel2: objectDataJson.customWorkspaceLabel2 || selectedContact?.customWorkspaceLabel2,
          customWorkspaceLabel3: objectDataJson.customWorkspaceLabel3 || selectedContact?.customWorkspaceLabel3,
          customWorkspaceUrl1: objectDataJson.customWorkspaceUrl1 || selectedContact?.customWorkspaceUrl1,
          customWorkspaceUrl2: objectDataJson.customWorkspaceUrl2 || selectedContact?.customWorkspaceUrl2,
          customWorkspaceUrl3: objectDataJson.customWorkspaceUrl3 || selectedContact?.customWorkspaceUrl3,
        }));
      })
      .catch((error) => {
        console.error('Error fetching object from S3:', error);
        setUpdatedContact((prev) => ({
          ...prev,
          customWorkspaceLabel1: selectedContact?.customWorkspaceLabel1,
          customWorkspaceLabel2: selectedContact?.customWorkspaceLabel2,
          customWorkspaceLabel3: selectedContact?.customWorkspaceLabel3,
          customWorkspaceUrl1: selectedContact?.customWorkspaceUrl1,
          customWorkspaceUrl2: selectedContact?.customWorkspaceUrl2,
          customWorkspaceUrl3: selectedContact?.customWorkspaceUrl3,
        }));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialObjectKey]);

  /**@example */
  const handleInputChange = (field: string, value: string) => {
    setUpdatedContact((prevContact: any) => ({
      ...prevContact,
      [field]: value,
    }));
  };

  useEffect(() => {
    dispatch(
      setSelectedContact({
        ...selectedContact,
        ...updatedContact,
      })
    );
  }, [updatedContact]);
  return (
    <CcfBox
      style={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      {(['Label1', 'Url1', 'Label2', 'Url2', 'Label3', 'Url3'] as const).map(
        (field) => {
          const key = `customWorkspace${field}` as CustomWorkspaceKey;
          return (
            <CcfBox key={field} className={styles.containerGrid}>
              <CcfTypography className={styles.inputLabel}>
                {field.toUpperCase().replace('URL', 'URL ')}
              </CcfTypography>
              <CcfTextField
                id={`sm_customWorkspace_${field}`}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '4px',
                    height: '36px',
                    border: '1px solid #AFC1CE',
                  },
                }}
                variant="outlined"
                value={updatedContact[key]}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleInputChange(key, event?.target.value);
                }}
                InputLabelProps={{ shrink: true }}
              />
            </CcfBox>
          );
        }
      )}
    </CcfBox>
  );
}
export default CustomWorkspace;
